/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AOCScoringCategoryModel, ScoringCategoryModel } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AocScoreCategory<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags AOCScoreCategory
   * @name ByAocGetAocScoreCategoriesByAocIdDetail
   * @request GET:/AOCScoreCategory/ByAOC/GetAOCScoreCategoriesByAOCId:{pageantAvailableEventId}
   */
  byAocGetAocScoreCategoriesByAocIdDetail = (pageantAvailableEventId: number, params: RequestParams = {}) =>
    this.request<AOCScoringCategoryModel[], any>({
      path: `/AOCScoreCategory/ByAOC/GetAOCScoreCategoriesByAOCId:${pageantAvailableEventId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AOCScoreCategory
   * @name AocScoreCategoryDetail
   * @request GET:/AOCScoreCategory/{id}
   */
  aocScoreCategoryDetail = (id: number, params: RequestParams = {}) =>
    this.request<AOCScoringCategoryModel, any>({
      path: `/AOCScoreCategory/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AOCScoreCategory
   * @name AocScoreCategoryUpdate
   * @request PUT:/AOCScoreCategory/{id}
   */
  aocScoreCategoryUpdate = (id: number, data: AOCScoringCategoryModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/AOCScoreCategory/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AOCScoreCategory
   * @name DeleteAocScoreCategory
   * @request DELETE:/AOCScoreCategory/{id}
   */
  deleteAocScoreCategory = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/AOCScoreCategory/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags AOCScoreCategory
   * @name GetAllScoringCategoriesList
   * @request GET:/AOCScoreCategory/GetAllScoringCategories
   */
  getAllScoringCategoriesList = (params: RequestParams = {}) =>
    this.request<ScoringCategoryModel[], any>({
      path: `/AOCScoreCategory/GetAllScoringCategories`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AOCScoreCategory
   * @name AocScoreCategoryCreate
   * @request POST:/AOCScoreCategory
   */
  aocScoreCategoryCreate = (data: AOCScoringCategoryModel, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/AOCScoreCategory`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
